<template>
  <div v-if="opened" class="resumo-lances">
    <a @click="opened = !opened" class="resumo-btn-close">Fechar</a>

    <div v-if="!leilao">Aguardando carregamento do leilão...</div>
    <div class="body" v-else>
      <table class="table table-striped">
        <thead>
        <tr>
          <th>Comitente</th>
          <th>Lotes</th>
          <th>Vendidos</th>
          <th>Não Vendidos</th>
          <th>Retirado</th>
          <th>Lotes com Lance</th>
          <th>Mínimo atingido</th>
          <th>Condicional</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="comitente in comitentes.comitentes">
          <td align="left">{{comitente.nome}}</td>
          <td align="left">{{comitente.lotes.length}}</td>
          <td align="left">{{comitente.vendidos}} ({{calculoPct(comitente.lotes.length,
            comitente.vendidos)}}%)</td>
          <td align="left">{{comitente.naoVendidos}} ({{calculoPct(comitente.lotes.length,
            comitente.naoVendidos)}}%)</td>
          <td align="left">{{comitente.retirados}} ({{calculoPct(comitente.lotes.length,
            comitente.retirados)}}%)</td>
          <td align="left">{{comitente.lotesComLance}}</td>
          <td align="left">{{comitente.minimoAtingido}}</td>
          <td align="left">{{comitente.condicional}}</td>
        </tr>
        <tr>
          <td align="left" class="font-bold"></td>
          <td align="left" class="font-bold">{{leilao.lotes.length}}</td>
          <td align="left" class="font-bold">{{comitentes.totais.vendidos}} ({{calculoPct(leilao.lotes.length,
            comitentes.totais.vendidos)}}%)
          </td>
          <td align="left" class="font-bold">{{comitentes.totais.naoVendidos}} ({{calculoPct(leilao.lotes.length,
            comitentes.totais.naoVendidos)}}%)
          </td>
          <td align="left" class="font-bold">{{comitentes.totais.retirados}} ({{calculoPct(leilao.lotes.length,
            comitentes.totais.retirados)}}%)
          </td>
          <td align="left" class="font-bold">{{comitentes.totais.lotesComLance}} ({{calculoPct(leilao.lotes.length,
            comitentes.totais.lotesComLance)}}%)
          </td>
          <td align="left" class="font-bold">{{comitentes.totais.minimoAtingido}} ({{calculoPct(leilao.lotes.length,
            comitentes.totais.minimoAtingido)}}%)</td>
          <td align="left" class="font-bold">{{comitentes.totais.condicional}} ({{calculoPct(leilao.lotes.length,
            comitentes.totais.condicional)}}%)</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResumoLances',
  props: ['leilao'],
  data () {
    return {
      opened: false
    }
  },
  computed: {
    comitentes () {
      let comitentes = []
      let totais = {
        lotesComLance: 0,
        minimoAtingido: 0,
        condicional: 0,
        vendidos: 0,
        naoVendidos: 0,
        retirados: 0
      }
      this.leilao.lotes.map(lote => {
        if (typeof comitentes[lote.comitente] === 'undefined') {
          comitentes[lote.comitente] = {
            nome: lote.comitente,
            lotes: [],
            lotesComLance: 0,
            minimoAtingido: 0,
            condicional: 0,
            vendidos: 0,
            naoVendidos: 0,
            retirados: 0
          }
        }
        let com = comitentes[lote.comitente]
        com.lotes.push(lote)
        if (lote.ultimoLanceArrematanteId) {
          com.lotesComLance++
          totais.lotesComLance++
        }

        if (Number(lote.valorMinimo) > 0) {
          if (Number(lote.ultimoLanceValor) > 0) {
            if (Number(lote.ultimoLanceValor) >= Number(lote.valorMinimo)) {
              com.minimoAtingido++
              totais.minimoAtingido++
            } else {
              com.condicional++
              totais.condicional++
            }
          }
        }

        if (Number(lote.status) === 6) {
          com.vendidos++
          totais.vendidos++
        }

        if (Number(lote.status) === 10) {
          com.retirados++
          totais.retirados++
        }

        if (Number(lote.status) === 8) {
          com.naoVendidos++
          totais.naoVendidos++
        }
      })
      return {
        comitentes: Object.values(comitentes),
        totais
      }
    }
  },
  methods: {
    open () {
      this.opened = true
    },
    close () {
      this.opened = false
    },
    calculoPct (a, b) {
      return this.round((b * 100) / a, 2)
    },
    round: function (number, precision) {
      let factor = Math.pow(10, precision)
      let tempNumber = number * factor
      let roundedTempNumber = Math.round(tempNumber)
      return roundedTempNumber / factor
    }
  }
}
</script>

<style lang="scss" scoped>
  .resumo-lances {
    position: fixed;
    right: 0;
    top: 80px;
    bottom: 0;
    width: 50%;
    background-color: #f2f2f2;
    z-index: 100;
    -webkit-box-shadow: -8px 10px 16px -6px rgba(0, 0, 0, 0.44);
    -moz-box-shadow: -8px 10px 16px -6px rgba(0, 0, 0, 0.44);
    box-shadow: -8px 10px 16px -6px rgba(0, 0, 0, 0.44);
    border-radius: 10px 0;
    display: flex;

    .resumo-btn-close {
      position: absolute;
      background-color: #ac2925;
      padding: 4px 10px;
      color: #FFFFFF;
      display: block;
      right: 20px;
      top: -10px;
    }

    .body {
      padding: 30px;
      flex: 1;
      overflow: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// ResumoLances.vue?34221435